import { render, staticRenderFns } from "./TabelaAreas.vue?vue&type=template&id=3e3e3294&scoped=true"
import script from "./TabelaAreas.vue?vue&type=script&lang=js"
export * from "./TabelaAreas.vue?vue&type=script&lang=js"
import style0 from "./TabelaAreas.vue?vue&type=style&index=0&id=3e3e3294&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3e3294",
  null
  
)

export default component.exports